import { throwError } from "@/lib/throwError";
import { get, post } from "@/services/axiosUitils";
import { ActionPayload } from "@/utils/types/userPreferencesGrid";

export default class UserPreferencesService {
  static addUserPreferencesGrid = async (
    payload: ActionPayload
  ): Promise<any> => {
    if (!payload) {
      throwError("Payload is required", "UserPreferencesService");
    }
    return await post("user-preferences-general/", payload);
  };

  static getUserPreferencesGrid = async (): Promise<any> => {
    return await get("user-preferences-general/");
  };
}
